const isMobile = () => window.innerWidth < 768

export default isMobile
